import React from "react";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import pageTitle from "../../utils/pageTitle";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    main: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }
}));

export default function AccessDenied() {
    pageTitle("Access Denied");

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Container component="main" className={classes.main} maxWidth="sm">
                <Typography variant="h4" component="h2" gutterBottom>
                    ACCESS DENIED!
                </Typography>
                <Typography variant="h6" component="h2" gutterBottom>
                    {"You are at the wrong place"}
                </Typography>
            </Container>
        </div>
    );
}

